import React from "react";

// Iron House Design System — IconButton (copiado do DS oficial, + import React).
export function IconButton(props) {
  const { icon, label, variant = "default", size = "md", disabled = false, onClick, className = "", ...rest } = props;

  const [hovered, setHovered] = React.useState(false);
  const [pressed, setPressed] = React.useState(false);

  const sizeMap = {
    sm: { width: "32px", height: "32px", fontSize: "14px" },
    md: { width: "40px", height: "40px", fontSize: "18px" },
    lg: { width: "48px", height: "48px", fontSize: "22px" },
  };

  const variantMap = {
    default: { background: hovered ? "var(--neutral-100)" : "transparent", color: "var(--text-primary)" },
    green: { background: hovered ? "var(--color-green-dark)" : "var(--color-green)", color: "var(--color-black)" },
    dark: { background: hovered ? "var(--neutral-800)" : "var(--color-black)", color: "var(--color-white)" },
    ghost: { background: hovered ? "rgba(255,255,255,0.1)" : "transparent", color: "var(--color-white)" },
  };

  const style = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    borderRadius: "var(--radius-full)",
    cursor: disabled ? "not-allowed" : "pointer",
    transition: `all var(--duration-fast) var(--ease-default)`,
    opacity: disabled ? 0.4 : 1,
    transform: pressed && !disabled ? "scale(0.93)" : "none",
    ...sizeMap[size],
    ...variantMap[variant],
  };

  return (
    <button
      style={style}
      className={className}
      onClick={disabled ? undefined : onClick}
      aria-label={label}
      title={label}
      disabled={disabled}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => {
        setHovered(false);
        setPressed(false);
      }}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      {...rest}
    >
      {icon}
    </button>
  );
}

export default IconButton;
